import { name } from "../../config/name.js";
const selectSelected = (state) => state[name].selected;
export {
  selectSelected
};
